import axios from "axios";
import { authHeaderFile, authHeaderJson } from "../auth-header.service";

const getListContractModification = (elementId = 0) => {
    return axios.get(`/api/Contract/contractmodification/${elementId}/list`, { headers: authHeaderJson() } )
};

const updateContractModification = (contractModificationId, objContractModification) => {
    return axios.put(`/api/Contract/contractmodification/update/${contractModificationId}`, objContractModification, { headers: authHeaderJson() });
};

const addContractModification = (objContractModification) => {
    return axios.post(`/api/Contract/contractmodification/add`, objContractModification, { headers: authHeaderJson() } );
};

const deleteContractModification = (contractModificationId) => {
    return axios.delete(`/api/Contract/contractmodification/delete/${contractModificationId}`, { headers: authHeaderJson() });
};

const updateContractModificationDocumentDeactivate = (documentId) => {
    return axios.post(`/api/Contract/contractmodificationdocumentdeactivate/${documentId}`, null, { headers: authHeaderJson() } )
};

const getListContractModificationDocuments = (contractModificationId) => {
    return axios.get(`/api/Contract/contractmodificationdocuments/${contractModificationId}/list`, { headers: authHeaderJson() } );
};

export {
    getListContractModification,
    updateContractModification,
    addContractModification,
    deleteContractModification,
    updateContractModificationDocumentDeactivate,
    getListContractModificationDocuments,

}